import { computed } from 'vue';

import { Placement, ServiceContextMap, ServiceSlug } from '@ply-io/ply-front-shared-utilities';

import { EmbeddedAppActionTypes, EmbeddedAppEntry } from './types';
import { service as zendeskService } from './zendesk';
export { EmbeddedAppActionTypes } from './types';
import { CreationProcess } from '@/components/CreationWizard/types';
import { useServices } from '@/composables';

const SLUG_TO_HANDLER: Record<ServiceSlug, EmbeddedAppEntry> = {
	zendesk: zendeskService,
};
const handleService = (slug: ServiceSlug, setCreationProcess: (cp: CreationProcess) => void) => {
	const { getServiceBySlug, getPlacements, getContexts } = useServices();
	const embeddedAppEntry = SLUG_TO_HANDLER[slug];
	const service = computed(() => getServiceBySlug.value(slug));
	embeddedAppEntry.init(setCreationProcess, service);
	const placements = computed<Placement[]>(() => (service.value ? getPlacements.value(service.value.id) : []));
	const contexts = computed<ServiceContextMap[]>(() => (service.value ? getContexts.value(service.value.id) : []));
	return { service, placements, contexts, embeddedAppEntry };
};

const bc = new BroadcastChannel('ply-sidebar');
type MessagePayload = { action: EmbeddedAppActionTypes; payload: Record<string, unknown> };
interface optionalPayloadMessagePayload extends Omit<MessagePayload, 'payload'> {
	payload?: MessagePayload['payload'];
}

const postPayloadMessage: (payload: MessagePayload) => void = (payload) => bc.postMessage(payload);
const sendMessage: (payload: optionalPayloadMessagePayload) => void = ({ action, payload = {} }) => postPayloadMessage({ action, payload });

const addBCListener = (callback: (payload: MessageEvent<MessagePayload>) => void) => {
	bc.addEventListener('message', callback);
};

const removeBCListener = (callback: (payload: MessageEvent<MessagePayload>) => void) => {
	bc.removeEventListener('message', callback);
};

export const useEmbeddedApp = () => ({ handleService, sendMessage, addBCListener, removeBCListener });
